import React, { memo } from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';

const TotalGeral = memo(({ servicos, selected, additionalSelected = [], cartProducts, isMensalista }) => {
  // Se não há produtos no carrinho e não há serviços selecionados (incluindo adicionais), não exibimos o total geral
  if (cartProducts.length === 0 && selected.length === 0 && additionalSelected.length === 0) {
    return null;
  }
  
  // Se o usuário é mensalista e não há produtos no carrinho e não há serviços adicionais, não exibimos o total geral
  if (isMensalista && cartProducts.length === 0 && additionalSelected.length === 0) {
    return null;
  }

  // Calcular o total dos serviços (apenas para não mensalistas)
  const totalServicos = !isMensalista ? selected.reduce((total, servicoId) => {
    const servico = servicos.find(s => s.id === servicoId);
    return total + (servico && typeof servico.valor === 'number' ? servico.valor : 0);
  }, 0) : 0;
  
  // Calcular o total dos serviços adicionais (para todos os usuários)
  const totalAdicionais = additionalSelected.reduce((total, servicoId) => {
    const servico = servicos.find(s => s.id === servicoId);
    return total + (servico && typeof servico.valor === 'number' ? servico.valor : 0);
  }, 0);

  // Calcular o total dos produtos
  const totalProdutos = cartProducts.reduce((total, product) => 
    total + (product.valor * (product.quantity || 1)), 0);

  // Total geral
  const totalGeral = totalServicos + totalProdutos + totalAdicionais;

  return (
    <Box
      p={6}
      bg="linear-gradient(180deg, rgba(45,55,72,0.9) 0%, rgba(26,32,44,0.9) 100%)"
      borderRadius="2xl"
      boxShadow="2xl"
      border="1px solid"
      borderColor="whiteAlpha.100"
      backdropFilter="blur(10px)"
      mb={6}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Text color="yellow.400" fontSize="2xl" fontWeight="bold">
          Total Geral:
        </Text>
        <Box 
          py={2} 
          px={4} 
          bg="yellow.40020"
          borderRadius="full"
          border="1px solid"
          borderColor="yellow.400"
        >
          <Text color="yellow.400" fontSize="3xl" fontWeight="bold">
            R$ {totalGeral.toFixed(2).replace('.', ',')}
          </Text>
        </Box>
      </Flex>

      {/* Detalhamento dos valores */}
      <Flex justifyContent="flex-end" mt={2}>
        <Box>
          {!isMensalista && selected.length > 0 && (
            <Text color="gray.300" fontSize="sm" textAlign="right">
              Serviços: R$ {totalServicos.toFixed(2).replace('.', ',')}
            </Text>
          )}
          
          {additionalSelected.length > 0 && (
            <Text color="gray.300" fontSize="sm" textAlign="right">
              Adicionais: R$ {totalAdicionais.toFixed(2).replace('.', ',')}
            </Text>
          )}
          
          {cartProducts.length > 0 && (
            <Text color="gray.300" fontSize="sm" textAlign="right">
              Produtos: R$ {totalProdutos.toFixed(2).replace('.', ',')}
            </Text>
          )}
        </Box>
      </Flex>
    </Box>
  );
});

export default TotalGeral;
